module.exports = __webpack_public_path__ + "static/media/globo-01.cd14eaf7.jpg";